<ng-template #modalTemplate>
  <div class="confirm-modal">
    <div class="flex-center-between">
      <h2 class="text-header-18">{{ config.title }}</h2>
      <app-st-icon (click)="close()" class="cursor-pointer" name="close" [bold]="true"></app-st-icon>
    </div>

    <p class="text-label-14 text-dark">{{ config.message }}</p>

    <!-- Textarea para casos especiales como rechazo -->
    @if (config.showTextarea) {
      <div>
        <p class="text-label-14 text-dark">Es necesario indicar el motivo para poder proceder.</p>
        <span class="text-label-10">Motivo</span>
        <textarea
          [(ngModel)]="config.textareaValue"
          rows="4"
          nz-input
          class="info-text"
          [placeholder]="config.textareaPlaceholder">
        </textarea>
      </div>
    }

    <!-- DatePicker para casos especiales como cambio de estado -->
    @if (config.showDatePicker) {
      <div>
        <span class="text-label-10">Fecha y hora</span>
        <nz-date-picker
          [(ngModel)]="config.dateValue"
          [nzShowTime]="true"
          nzFormat="yyyy-MM-dd HH:mm"
          [nzAllowClear]="false"
          style="width: 100%; margin-top: 8px;">
        </nz-date-picker>
      </div>
    }

    <div class="flex-center-between footer">
      <button
        (click)="close()"
        nz-button
        nzShape="round"
        nzSize="large"
        nzType="text">
        {{ config.cancelText }}
      </button>

      <button
        (click)="confirm()"
        [disabled]="isConfirmDisabled()"
        nz-button
        nzShape="round"
        nzSize="large"
        [nzType]="config.confirmButtonType || 'primary'"
        [nzDanger]="config.confirmButtonDanger">
        @if (config.processing) {
          <app-st-icon class="prefix" [bold]="true" name="progress_activity"></app-st-icon>
        }
        {{ config.confirmText }}
      </button>
    </div>
  </div>
</ng-template>
